module.exports = __webpack_public_path__ + "img/icon_detail.7547d665.svg";